function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useMemo } from 'react';
import { clampPage, clampPageLoop, isFunction, isNumber, isUndefined } from '@okee-uikit/react-utils';
import { useConstCallback, useRefCallback } from '../callback';
import { useConst } from '../state';
import { usePartial } from './partial';
var DEFAULT_PAGE = 1;
var DEFAULT_SIZE = 10;
var DEFAULT_TOTAL = 100;
export function usePagination() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var value = options.value,
      defaultValue = options.defaultValue,
      onChange = options.onChange,
      controlled = options.controlled,
      _options$page = options.page,
      page = _options$page === void 0 ? value : _options$page,
      _options$deafultPage = options.deafultPage,
      deafultPage = _options$deafultPage === void 0 ? defaultValue : _options$deafultPage,
      _options$onPageChange = options.onPageChange,
      onPageChange = _options$onPageChange === void 0 ? onChange : _options$onPageChange,
      _options$pageControll = options.pageControlled,
      pageControlled = _options$pageControll === void 0 ? controlled : _options$pageControll,
      size = options.size,
      _options$defaultSize = options.defaultSize,
      defaultSize = _options$defaultSize === void 0 ? DEFAULT_SIZE : _options$defaultSize,
      onSizeChange = options.onSizeChange,
      sizeControlled = options.sizeControlled,
      _options$total = options.total,
      optionTotal = _options$total === void 0 ? DEFAULT_TOTAL : _options$total,
      _options$clamp = options.clamp,
      clamp = _options$clamp === void 0 ? true : _options$clamp,
      _options$loop = options.loop,
      loop = _options$loop === void 0 ? false : _options$loop,
      onStateChange = options.onStateChange;
  var total = Math.abs(Math.trunc(optionTotal));

  var _usePartial = usePartial({
    value: {
      page: page,
      size: size
    },
    onChange: onStateChange,
    controlled: false,
    defaultValue: {
      page: function () {
        var initialValue = isFunction(deafultPage) ? deafultPage() : deafultPage;

        if (!isNumber(initialValue)) {
          return DEFAULT_PAGE;
        }

        var pageCount = Math.ceil(total / (size || DEFAULT_SIZE)) || 1;
        return loop ? clampPageLoop(initialValue, pageCount) : clampPage(initialValue, pageCount);
      }(),
      size: function () {
        var initialValue = isFunction(defaultSize) ? defaultSize() : defaultSize;

        if (!isNumber(initialValue)) {
          return DEFAULT_SIZE;
        }

        return Math.floor(initialValue);
      }()
    },
    partControlled: {
      page: pageControlled || isUndefined(pageControlled) && !isUndefined(page),
      size: sizeControlled || isUndefined(sizeControlled) && !isUndefined(size)
    },
    onPartChange: {
      page: onPageChange,
      size: onSizeChange
    }
  }),
      _usePartial2 = _slicedToArray(_usePartial, 2),
      _usePartial2$ = _usePartial2[0],
      _usePartial2$$page = _usePartial2$.page,
      innerPage = _usePartial2$$page === void 0 ? DEFAULT_PAGE : _usePartial2$$page,
      _usePartial2$$size = _usePartial2$.size,
      innerSize = _usePartial2$$size === void 0 ? DEFAULT_SIZE : _usePartial2$$size,
      paginationActions = _usePartial2[1];

  var pageCount = Math.ceil(total / innerSize) || 1;
  var state = useMemo(function () {
    return {
      page: clamp ? Math.min(innerPage, pageCount) : innerPage,
      size: innerSize,
      total: total,
      pageCount: pageCount
    };
  }, [innerPage, innerSize, total, pageCount, clamp]);
  var setSize = useConstCallback(function (updater, event) {
    return paginationActions.setValue(function (pre) {
      var newValue = isFunction(updater) ? updater(pre.size || DEFAULT_SIZE) : updater;
      var pageCount = Math.ceil(total / (newValue || DEFAULT_SIZE)) || 1;
      var page = pre.page && pre.page < pageCount ? pre.page : pageCount;
      return {
        size: newValue,
        page: page
      };
    }, event);
  });
  var setPage = useRefCallback(function (updater, event) {
    return paginationActions.setPartial(function (_ref) {
      var page = _ref.page;
      var newValue = isFunction(updater) ? updater(page !== null && page !== void 0 ? page : DEFAULT_PAGE) : updater;

      if (!isNumber(newValue)) {
        return {
          page: page
        };
      }

      return {
        page: loop ? clampPageLoop(newValue, pageCount) : clampPage(newValue, pageCount)
      };
    }, event);
  });
  var next = useConstCallback(function (event) {
    return setPage(function (pre) {
      return pre + 1;
    }, event);
  });
  var previous = useConstCallback(function (event) {
    return setPage(function (pre) {
      return pre + 1;
    }, event);
  });
  var actions = useConst({
    setPage: setPage,
    next: next,
    previous: previous,
    setSize: setSize
  });
  return [state, actions];
}